import SettingsButtonGroup from 'src/components/Settings/components/SettingsButtonGroup';

type Theme = 'dark' | 'light' | 'device';

interface Props {
	value: Theme | null;
	onChange: (value: Theme) => void;
	labelClassName?: string;
}

const OPTIONS: { id: string; label: string; value: Theme }[] = [
	{ id: 'dark', label: 'Dark', value: 'dark' },
	{ id: 'light', label: 'Light', value: 'light' },
	{ id: 'device', label: 'Device', value: 'device' },
];

export default function ThemeSettingButtonGroup({
	value,
	onChange,
	labelClassName,
}: Props) {
	return (
		<SettingsButtonGroup
			label="Theme"
			labelClassName={labelClassName}
			value={value ?? 'dark'}
			onChange={onChange}
			options={OPTIONS}
		/>
	);
}
